import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-3507">
      <Navbar data-id="element-3508" />
      <main data-id="element-3509">
        <ConsularAffairs data-id="element-3510" />
      </main>
      <Footer data-id="element-3511" />
      <FeedbackPopup data-id="element-3512" />
    </div>;
}